// @ts-nocheck
import { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Checkbox } from "../../components/ui/checkbox";
import { Switch } from "../../components/ui/switch";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from "../../components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Plus, User, Search } from "lucide-react";
import { Trash } from "@phosphor-icons/react";

function formatOutputRoles(role) {
  // Se a string for "[]", retorna um array vazio
  if (role === "[]") {
    return [];
  }
  // Caso contrário, continua com a lógica original
  const roleArray = role
    .slice(1, -1)
    .split(",")
    .map((r) => r.trim())
    .filter(Boolean); // Remove strings vazias
  return roleArray;
}

const AVAILABLE_ROLES = [
  { id: "admin", label: "Administrador" },
  { id: "tim_toa", label: "Tim TOA" },
  { id: "fleet_manager", label: "Gestor de Frota" },
  { id: "rh", label: "Gestão de Pessoas" },
];

export function Users() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [newUserEmail, setNewUserEmail] = useState("");
  const [newUserName, setNewUserName] = useState("");
  const [newUserActive, setNewUserActive] = useState(true);
  const [newUserRoles, setNewUserRoles] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editForm, setEditForm] = useState({
    nome: "",
    email: "",
    roles: [],
  });
  const [emailIsValidated, setEmailIsValidated] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    const filtered = users.filter((user) =>
      user.nome.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUsers(filtered);
  }, [searchTerm, users]);

  const fetchUsers = async () => {
    try {
      const { data } = await axios.get("https://radar.tlpservicos.com.br/api/users");
      setUsers(data);
      setFilteredUsers(data);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
    }
  };

  const handleCreateUser = async () => {
    try {
      const body = {
        nome: newUserName,
        email: newUserEmail,
        ativo: newUserActive,
        role: formatRoleToUpdate(newUserRoles),
      };
      await axios.post("https://radar.tlpservicos.com.br/api/user", body);
      setCreateModalOpen(false);
      setNewUserEmail("");
      setNewUserName("");
      setNewUserActive(true);
      setNewUserRoles([]);
      fetchUsers();
    } catch (error) {
      console.error("Erro ao criar usuário:", error);
    }
  };

  const handleEditUser = (user) => {
    const userRoles = formatOutputRoles(user.role);
    setSelectedUser(user);
    setEditForm({
      nome: user.nome,
      email: user.email || "",
      roles: userRoles,
    });
    setEditModalOpen(true);
  };

  const handleDeleteUser = async (user) => {
    await axios.delete(`https://radar.tlpservicos.com.br/api/user/${user.id}`);
  };

  const toggleRole = (roleId) => {
    setEditForm((prev) => ({
      ...prev,
      roles: prev.roles.includes(roleId)
        ? prev.roles.filter((r) => r !== roleId)
        : [...prev.roles, roleId],
    }));
  };

  const toggleNewUserRole = (roleId) => {
    setNewUserRoles((prev) =>
      prev.includes(roleId) ? prev.filter((r) => r !== roleId) : [...prev, roleId]
    );
  };

  function formatRoleToUpdate(role) {
    return JSON.stringify(role).replaceAll('"', "");
  }

  const handleSaveChanges = async () => {
    formatRoleToUpdate(editForm.roles);
    try {
      await axios.put(`https://radar.tlpservicos.com.br/api/user/${selectedUser.id}`, {
        nome: editForm.nome,
        email: editForm.email,
        role: formatRoleToUpdate(editForm.roles),
      });
      setEditModalOpen(false);
      fetchUsers();
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
    }
  };

  function validateEmail(email) {
    const arrayEmail = email.split("@");
    if (arrayEmail.length === 2) {
      if (arrayEmail[1] === "tlpservicos.com.br" || arrayEmail[1] === "tlpcp.com.br") {
        setEmailIsValidated(true);
      } else {
        setEmailIsValidated(false);
      }
    }
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Gerenciar Usuários</h2>
        <Dialog open={createModalOpen} onOpenChange={setCreateModalOpen}>
          <DialogTrigger asChild>
            <Button className="flex items-center gap-2 bg-gray-200">
              <Plus size={16} />
              Criar Usuário
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Criar Novo Usuário</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <label>Email</label>
                <Input
                  type="email"
                  value={newUserEmail}
                  onChange={(e) => {
                    setNewUserEmail(e.target.value);
                    validateEmail(e.target.value);
                  }}
                  placeholder="Digite o email"
                />
              </div>
              <div className="space-y-2">
                <label>Nome</label>
                <Input
                  value={newUserName}
                  onChange={(e) => setNewUserName(e.target.value)}
                  placeholder="Digite o nome"
                />
              </div>
              <div className="flex items-center space-x-2">
                <Switch
                  id="user-active"
                  checked={newUserActive}
                  onCheckedChange={setNewUserActive}
                />
                <label htmlFor="user-active">Usuário Ativo</label>
              </div>
              <div className="space-y-2">
                <label className="block mb-2">Permissões de Acesso</label>
                <div className="space-y-2">
                  {AVAILABLE_ROLES.map((role) => (
                    <div key={role.id} className="flex items-center space-x-2">
                      <Checkbox
                        id={`new-${role.id}`}
                        checked={newUserRoles.includes(role.id)}
                        onCheckedChange={() => toggleNewUserRole(role.id)}
                      />
                      <label htmlFor={`new-${role.id}`}>{role.label}</label>
                    </div>
                  ))}
                </div>
              </div>
              <Button
                onClick={handleCreateUser}
                className={`w-full ${!emailIsValidated ? "cursor-not-allowed" : ""}`}
                disabled={!emailIsValidated}
              >
                Criar
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <div className="mb-4 flex items-center gap-2">
        <Search className="text-gray-400" size={20} />
        <Input
          placeholder="Buscar por nome de usuário"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="max-w-sm"
        />
      </div>

      <div className="">
        <Table>
          <TableHeader>
            <TableRow className="">
              <TableHead className="h-10">ID</TableHead>
              <TableHead className="h-10">Nome</TableHead>
              <TableHead className="h-10">Email</TableHead>
              <TableHead className="h-10">Acessos</TableHead>
              <TableHead className="h-10">Alteração</TableHead>
              <TableHead className="h-10">Deletar</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredUsers.map((user) => (
              <TableRow key={user.id} className="h-4">
                <TableCell className="py-2">{user.id}</TableCell>
                <TableCell className="py-2">{user.nome}</TableCell>
                <TableCell className="py-2">
                  {user.email ? user.email : "sem email"}
                </TableCell>
                <TableCell className="py-2">{user.role.slice(1, -1)}</TableCell>
                <TableCell className="py-2">
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => handleEditUser(user)}
                  >
                    <User size={16} />
                  </Button>
                </TableCell>
                <TableCell className="py-2 ">
                  <Dialog open={deleteModalOpen} onOpenChange={setDeleteModalOpen}>
                    <DialogTrigger asChild>
                      <Trash
                        className="cursor-pointer hover:text-red-500 transition-colors"
                        size={16}
                      />
                    </DialogTrigger>
                    <DialogContent>
                      <DialogHeader>
                        <DialogTitle>Deletar Usuário</DialogTitle>
                      </DialogHeader>
                      <div className="flex flex-row items-center justify-center gap-4">
                        <Button
                          onClick={() => {
                            handleDeleteUser(user);
                            fetchUsers();
                            setDeleteModalOpen(false);
                          }}
                          className="w-full bg-red-800 hover:bg-red-600 text-white font-medium py-2 px-4 rounded transition-colors duration-200"
                        >
                          Deletar
                        </Button>
                        <Button
                          onClick={() => setDeleteModalOpen(false)}
                          className={`w-full`}
                        >
                          Cancelar
                        </Button>
                      </div>
                    </DialogContent>
                  </Dialog>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <Dialog open={editModalOpen} onOpenChange={setEditModalOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Editar Usuário</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <label>Nome</label>
              <Input
                value={editForm.nome}
                onChange={(e) =>
                  setEditForm((prev) => ({ ...prev, nome: e.target.value }))
                }
              />
            </div>
            <div className="space-y-2">
              <label>Email</label>
              <Input
                type="email"
                value={editForm.email}
                onChange={(e) =>
                  setEditForm((prev) => ({ ...prev, email: e.target.value }))
                }
              />
            </div>
            <div className="space-y-2">
              <label className="block mb-2">Permissões de Acesso</label>
              <div className="space-y-2">
                {AVAILABLE_ROLES.map((role) => (
                  <div key={role.id} className="flex items-center space-x-2">
                    <Checkbox
                      id={role.id}
                      checked={editForm.roles.includes(role.id)}
                      onCheckedChange={() => toggleRole(role.id)}
                    />
                    <label htmlFor={role.id}>{role.label}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditModalOpen(false)}>
              Cancelar
            </Button>
            <Button onClick={handleSaveChanges}>Salvar Alterações</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default Users;
